import * as Types from '../../@types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetAllGraduationApplyQueryVariables = Types.Exact<{
  currentYearStart?: Types.InputMaybe<Types.Scalars['DateTime']['input']>;
  currentYearEnd?: Types.InputMaybe<Types.Scalars['DateTime']['input']>;
}>;


export type GetAllGraduationApplyQuery = { __typename?: 'Query', afGraduationApplication: Array<{ __typename?: 'Club_WorldFamilyClub_GraduationApplication', id: string, age?: string | null, applicationDate?: any | null, audioFile?: string | null, childEnglishName?: string | null, childName?: string | null, childNo?: string | null, isExcellent?: boolean | null, market?: string | null, memberNo?: string | null, taskId?: number | null, videoUrl?: string | null, isPassed?: boolean | null, approvalDate?: any | null, overallComment?: string | null, updater?: string | null, graduationSubApplications?: Array<{ __typename?: 'Club_WorldFamilyClub_GraduationSubApplication', id: string, applicationId?: number | null, subTaskId?: number | null, subTask?: { __typename?: 'Club_WorldFamilyClub_GraduationApplicationSubTask', graduationSubTaskMarketDescriptions?: Array<{ __typename?: 'Club_WorldFamilyClub_GraduationSubTaskMarketDescription', market?: string | null, subTaskId?: number | null, subTaskName?: string | null } | null> | null } | null } | null> | null }> };


export const GetAllGraduationApplyDocument = gql`
    query GetAllGraduationApply($currentYearStart: DateTime, $currentYearEnd: DateTime) {
  afGraduationApplication(
    filter: {applicationDate: {gt: $currentYearStart, lt: $currentYearEnd}}
  ) {
    id
    age
    applicationDate
    audioFile
    childEnglishName
    childName
    childNo
    isExcellent
    market
    memberNo
    taskId
    videoUrl
    graduationSubApplications {
      id
      applicationId
      subTaskId
      subTask {
        graduationSubTaskMarketDescriptions {
          market
          subTaskId
          subTaskName
        }
      }
    }
    isPassed
    approvalDate
    overallComment
    updater
  }
}
    `;

/**
 * __useGetAllGraduationApplyQuery__
 *
 * To run a query within a React component, call `useGetAllGraduationApplyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllGraduationApplyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllGraduationApplyQuery({
 *   variables: {
 *      currentYearStart: // value for 'currentYearStart'
 *      currentYearEnd: // value for 'currentYearEnd'
 *   },
 * });
 */
export function useGetAllGraduationApplyQuery(baseOptions?: Apollo.QueryHookOptions<GetAllGraduationApplyQuery, GetAllGraduationApplyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllGraduationApplyQuery, GetAllGraduationApplyQueryVariables>(GetAllGraduationApplyDocument, options);
      }
export function useGetAllGraduationApplyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllGraduationApplyQuery, GetAllGraduationApplyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllGraduationApplyQuery, GetAllGraduationApplyQueryVariables>(GetAllGraduationApplyDocument, options);
        }
export type GetAllGraduationApplyQueryHookResult = ReturnType<typeof useGetAllGraduationApplyQuery>;
export type GetAllGraduationApplyLazyQueryHookResult = ReturnType<typeof useGetAllGraduationApplyLazyQuery>;
export type GetAllGraduationApplyQueryResult = Apollo.QueryResult<GetAllGraduationApplyQuery, GetAllGraduationApplyQueryVariables>;